export default "__VITE_ASSET__e992d701__"